import {
  getSurfaceTileGridLayout,
  SURFACE_GRID_GAP,
} from "@-/dev.improve.haniverse.components.ui.surface";

export const LESSON_LEVEL_GRID_INSET = 4;

/** Distance from either endpoint tile of the level intersecting a viewport edge. */
export function getLessonLevelEdgeFadeDistance(
  layouts: readonly { length: number; offset: number; tileSize: number }[],
  edgeOffset: number,
) {
  const layout = layouts.find(
    (entry) => edgeOffset >= entry.offset && edgeOffset < entry.offset + entry.length,
  );
  if (layout === undefined) {
    return 0;
  }
  const position = edgeOffset - layout.offset;
  // First and last tiles stay whole, including the gutter beside them. Only interior tiles fade.
  const endpointWidth = layout.tileSize + LESSON_LEVEL_GRID_INSET;
  return Math.max(0, Math.min(position - endpointWidth, layout.length - endpointWidth - position));
}

/** One row, with Browse-sized tiles regardless of how many cards a level contains. */
export function getLessonLevelGridLayout({
  count,
  maxHeight,
  width,
}: {
  count: number;
  maxHeight?: number;
  width: number;
}) {
  const innerWidth = Math.max(1, width - LESSON_LEVEL_GRID_INSET * 2);
  const { glyphColumns } = getSurfaceTileGridLayout(innerWidth, 0);
  const tileSize = Math.max(
    1,
    Math.min(
      (innerWidth - (glyphColumns - 1) * SURFACE_GRID_GAP) / glyphColumns,
      maxHeight === undefined ? Number.POSITIVE_INFINITY : maxHeight - LESSON_LEVEL_GRID_INSET * 2,
    ),
  );
  return {
    columns: Math.max(1, count),
    gridWidth: count * tileSize + Math.max(0, count - 1) * SURFACE_GRID_GAP,
    tileSize,
  };
}

/** Show 1½ preceding tiles, clamped to this level's start/end so no empty tail appears. */
export function getLessonLevelScrollOffset({
  activeIndex,
  count,
  tileSize,
  width,
}: {
  activeIndex: number;
  count: number;
  tileSize: number;
  width: number;
}) {
  const pitch = tileSize + SURFACE_GRID_GAP;
  const contentWidth = count * pitch - SURFACE_GRID_GAP + LESSON_LEVEL_GRID_INSET * 2;
  return Math.max(
    0,
    Math.min(activeIndex * pitch - tileSize * 1.5 - SURFACE_GRID_GAP, contentWidth - width),
  );
}
